import { BaseContainerModel } from '../base-container.model';

export class FpxRequestMessageModel extends BaseContainerModel {
  fpx_msgType: string;
  fpx_msgToken: string;
  fpx_sellerExId: string;
  fpx_sellerExOrderNo: string;
  fpx_sellerTxnTime: string;
  fpx_sellerOrderNo: string;
  fpx_sellerId: string;
  fpx_sellerBankCode: string;
  fpx_txnCurrency: string;
  fpx_txnAmount: string;
  fpx_buyerEmail: string;
  fpx_buyerName: string;
  fpx_buyerBankId: string;
  fpx_buyerBankBranch: string;
  fpx_buyerAccNo: string;
  fpx_buyerId: string;
  fpx_makerName: string;
  fpx_buyerIban: string;
  fpx_productDesc: string;
  fpx_version: string;
  fpx_checkSum: string;

  fpx_buyerBankName: string;

  fpx_creditAuthCode: string;
  fpx_creditAuthNo: string;
  fpx_debitAuthCode: string;
  fpx_debitAuthNo: string;
  fpx_fpxTxnId: string;
  fpx_fpxTxnTime: string;

  fpx_eMandateAmt: string;
}

export class BuyerIban {
  applicationType: string; // 01 - New Application / 02 – Maintenance / 03 - Termination
  phoneNumber: string;
  maximumFrequency: number;
  frequencyMode: string; // DL – Daily / WK – Weekly / MT – Monthly / YR - Yearly
  effectiveDate: string; //DDMMYY
  expiryDate: string; //DDMMYY
}
